import { render } from "./EmailOnboardingProvider.vue?vue&type=template&id=1cfd3a1a&scoped=true"
import script from "./EmailOnboardingProvider.vue?vue&type=script&lang=js"
export * from "./EmailOnboardingProvider.vue?vue&type=script&lang=js"

import "./EmailOnboardingProvider.vue?vue&type=style&index=0&id=1cfd3a1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfd3a1a"]])

export default __exports__